import { render } from "./VacanciesBanner.vue?vue&type=template&id=faa00d1a&scoped=true"
import script from "./VacanciesBanner.vue?vue&type=script&lang=js"
export * from "./VacanciesBanner.vue?vue&type=script&lang=js"

import "./VacanciesBanner.vue?vue&type=style&index=0&id=faa00d1a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa00d1a"]])

export default __exports__